import { lazy } from "react";

const SystemSubscriptionsPage = lazy(() => import("@/widgets/system-admin/subscriptions/SubscriptionsPage"));

const SystemSubscriptionRoutes = {
  path: "subscriptions",
  children: [{ index: true, element: <SystemSubscriptionsPage /> }],
};

export default SystemSubscriptionRoutes;
